import {LAYOUT_TYPES} from '~/components/common/pages_constants';

export enum LAYOUT_MODES {
  WINDOW = 'window',
  PROJECT_EDITION = 'project edition',
  MODAL = 'modal',
  LANDING = 'landing',
}

export const PROPORTIONS = {
  [LAYOUT_TYPES.FULL_SCREEN]: 'grid-cols-[0_1fr]',
  [LAYOUT_TYPES.HALF_VIEW]: 'grid-cols-[45%_55%]',
  [LAYOUT_TYPES.THIRD_VIEW]: 'grid-cols-[35%_1fr]',
  [LAYOUT_TYPES.THIRD_VIEW_FULL_HEIGHT_CONTENT]: 'grid-cols-[35%_1fr]',
  [LAYOUT_TYPES.SMALLEST_VIEW]: 'grid-cols-[15%_1fr]',
  [LAYOUT_TYPES.HIDDEN]: 'grid-cols-[1fr_0]',
};
